module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Sorry, but this page does not exist","note":"Maybe one of the options from the menu could be helpful."},"cs":{"title":"Je nám to líto, ale tato stránka neexistuje","note":"Možná Vás zaujme některé z položek v nabídce menu."}}')
  delete Component.options._Ctor
}
